import { apiV1 } from "api-v2";
import type { CountryLocationGroup } from "./types";

export const getServiceabilityLocationTree = async (): Promise<
	CountryLocationGroup[]
> => {
	const { data } = await apiV1.get("serviceability-locations");
	return data.data;
};
